export const MAX_COMBINED_SIZE_OF_FILE_UPLOADS = 20 * 1024 * 1024; // 20MB
export const USER_ERROR_PREFIX = "[USER_ERROR]";
export const ALLOWED_FILE_TYPE_EXTENSIONS =
  ".pdf,.jpg,.jpeg,.png,.gif,.xls,.xlsx,.doc,.docx";
export const EMAIL_DOCUMENT_TO_US_COPY =
  "If you are unable to upload a document, please email it to intermediaries@getabound.com";
